import React from 'react';
// eslint-disable-next-line no-unused-vars
import ModelCheck from '../model/ModelCheck';

const Disclaimer = (props) => {
    const isMobile = window.innerWidth < 768
    /** @type {ModelCheck} */
    const check = props.data
    return (
        <div className='disclaimer'>
            <p>
                KitLegit Ltd is not sponsored by or affiliated with any leagues, teams or manufactures. KitLegit's authentication service is based solely the images provided by the user, and KitLegit's own proprietary algorithm and brand protection experience.  The databases relied upon are not based upon data provided by any of the brands and manufacturers listed on the website or application. The legal entities listed or mentioned on the KitLegit website or application are neither responsible for nor bound by any of KitLegit's findings and may not honor any certificates of authenticity provided by KitLegit Ltd. KitLegit Ltd is protected by copyright. Unsanctioned manipulation or misuse of this certificate is prohibited and may be punishable by law.
            </p>
        </div>
    )
}

export default Disclaimer